import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.group.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-group-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.group.list/view.scss */
/* src/app/portal.gsdcuser.group.list/view.scss: no such file or directory */`],
})
export class PortalGsdcuserGroupListComponent implements OnInit {

    public groups: any = [];
    public loading: boolean = false;

    // 신규 그룹 생성
    public groupName: string = '';
    public groupDescription: string = '';
    public createOpen: boolean = false;

    // 그룹 추가 가입
    public selectedGroup: string = '';
    public selectedRepresentative: string = '';
    public availableGroups: any[] = [];
    public availableRepresentatives: any[] = [];
    public joinOpen: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code != 200) return;
        this.groups = data;
        console.log(this.groups)

        await this.service.render();
    }

    // 신규 그룹 생성
    public async create() {
        this.createOpen = true;
        await this.service.render();
    }
    public async closeCreate() {
        this.createOpen = false;
        this.groupName = "";
        this.groupDescription = "";
        await this.service.render();
    }
    public async submitGroupRequest() {
        if (!this.groupName || !this.description) {
            return await this.service.alert.error("그룹 이름과 설명을 입력해 주세요.");
        }

        const confirmed = await this.service.alert.success("신규 그룹 생성을 요청하시겠습니까?", "취소");

        // 사용자가 확인 버튼을 클릭한 경우에만 진행
        if (!confirmed) return;
        this.service.loading.show(); // 로딩 시작
        const { code, message } = await wiz.call("submit_group_request", {
            name: this.groupName,
            description: this.groupDescription
        });
        this.service.loading.hide(); // 로딩 시작

        if (code === 200) {
            await this.service.alert.success("그룹 생성 요청이 성공적으로 제출되었습니다.");
            this.location.back();
        } else {
            await this.service.alert.error(message || "그룹 생성 요청에 실패했습니다.");
        }
    }

    // 그룹 추가 가입
    public async join() {
        this.joinOpen = true;
        await this.service.render();

        const { code, data } = await wiz.call("get_available_groups");
        if (code != 200) return await this.service.alert.error("그룹 목록을 불러오는 중 오류가 발생했습니다.");
        this.availableGroups = data;
        await this.service.render();
    }
    public async closeJoin() {
        this.joinOpen = false;
        this.selectedGroup = '';
        this.selectedRepresentative = '';
        this.availableGroups = [];
        this.availableRepresentatives = [];
        await this.service.render();
    }
    // 그룹 추가 가입 -> 그룹 선택
    public async loadRepresentatives() {
        if (!this.selectedGroup) return;

        const { code, data } = await wiz.call("get_group_representatives", { group_id: this.selectedGroup });
        if (code != 200) return await this.service.alert.error("대표자 목록을 불러오는 중 오류가 발생했습니다.");

        this.availableRepresentatives = data;
        await this.service.render();
    }
    // 그룹 추가 가입 -> 요청 제출
    public async submitJoinRequest() {
        if (!this.selectedGroup || !this.selectedRepresentative) return await this.service.alert.warning("그룹과 대표자를 선택해 주세요.");

        const confirmed = await this.service.alert.success("선택한 그룹에 추가 가입 요청을 하시겠습니까?", "취소");

        if (!confirmed) return;

        this.service.loading.show(); // 로딩 시작
        const { code, message } = await wiz.call("submit_join_request", {
            group_id: this.selectedGroup,
            request_pi: this.selectedRepresentative
        });
        this.service.loading.hide(); // 로딩 종료

        if (code != 200) await this.service.alert.error(message || "그룹 추가 가입 요청에 실패했습니다.");

        await this.service.alert.success("그룹 추가 가입 요청이 성공적으로 제출되었습니다.");
        this.joinOpen = false;
        await this.service.render();
    }
}

export default PortalGsdcuserGroupListComponent;